import { IMutations, IMutationsTemplatePayload } from './mutations.types';
import { IReviewForm } from '@/entities';
import { AppConstants } from '@/shared/app.constants';


export const mutations: IMutations = {

    setSelectedApplication(state: IReviewForm, payload: number): void {
        state.applicationId = payload;
    },
    setSelectedReview(state: IReviewForm, payload: number): void {
        state.reviewId = payload;
    },
    setTemplate(state: IReviewForm, payload: IMutationsTemplatePayload): void {
        state.templateList = payload;  
    },
    setPrefilledData(state: IReviewForm, payload: any) {
        if(payload) {
            state.override = payload.override;
            state.totalScore = payload.totalScore;
            state.overallRating = payload.overallRating;
            state.comment = payload.comment;
            state.recommendation = payload.recommendation;
            state.reviews = payload.reviews;
            state._id = payload._id;
            state.reviewerId = payload.reviewerId;
            state.applicationId = payload.applicationId;
            state.version = payload.version;
            state.status = payload.status;
            state.auditInfo = payload.auditInfo;
            state.reviewId = payload.reviewId;
        } else {
            state.totalScore = 0;
            state.overallRating = undefined;
            state.comment = undefined;
            state.recommendation = undefined;
            state.override = false;
            state.reviews = [];
            state.auditInfo = {};
            state._id = undefined;
            state.status = AppConstants.reviewStatus.In_Progress;
        }
    },
    setLanguage(state: IReviewForm, payload: string) {
        state.language = payload;
    },
    refreshTemplates(state: IReviewForm) {
        if(state.templateList[state.language]){
            state.usedTemplate = state.templateList[state.language];
        }
    },
    /** re-assigning review data */
    setReview(state: IReviewForm, payload: any) {
        state.totalScore = payload.totalScore;
        state.overallRating = payload.overallRating;
        state.comment = payload.comment;
        state.recommendation = payload.recommendation;
        state.override = payload.override;
        state.reviews = payload.reviews;
        state._id = payload._id;
        state.applicationId = payload.applicationId;
        state.reviewerId = payload.reviewerId;
        state.version = payload.version;
        state.status = payload.status;
        state.auditInfo = payload.auditInfo;
    },

    setNotification(state: IReviewForm, payload: any) {
        state.notification.text = payload.text;
        state.notification.snack = true;
        state.notification.timeOut = payload.timeOut || 6000;
        state.notification.color = payload.color || 'success';
    }
}